//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "directSection",
  props: {
    increaseFooterSpacingLaptop: {
      type: Boolean,
      default: false,
    },
    arrowUp: {
      type: Boolean,
      default: false,
    },
    hideBorder: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    handleScrollDown() {
      window.scrollTo({
        top: document.documentElement.scrollTop + window.innerHeight/2,
        behavior: "smooth",
      });
    },
    handleScrollUp() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }
};
